module.exports = __webpack_public_path__ + "img/slide-1-mob.2b2942f.webp";